import { MAX_ASK_PUNTT_CHAT_TITLE_LENGTH } from "@mg/schemas/src/christo/askPuntt";

import { BreadcrumbInlineRename } from "./BreadcrumbInlineRename";

import { useRenameAskPunttChat } from "../../../utils/queries/askPuntt";

interface ChatBreadcrumbTitleProps {
  chatId: string;
  title: string;
  /** Only the chat owner may rename. Non-owners get a read-only title. */
  canEdit: boolean;
}

/**
 * The chat title in the breadcrumb at the top of the chat view. For the owner
 * it doubles as a clean inline rename affordance via {@link BreadcrumbInlineRename}:
 * the resting title is plain breadcrumb text (no box), and a hover-revealed
 * overlay pencil lets the owner edit in place. Errors revert via the mutation's
 * optimistic rollback + toast.
 */
export function ChatBreadcrumbTitle({
  chatId,
  title,
  canEdit,
}: ChatBreadcrumbTitleProps) {
  const renameMutation = useRenameAskPunttChat();

  return (
    <BreadcrumbInlineRename
      title={title}
      canEdit={canEdit}
      isPending={renameMutation.isPending}
      onRename={(next) => renameMutation.mutate({ chatId, title: next })}
      maxLength={MAX_ASK_PUNTT_CHAT_TITLE_LENGTH}
      triggerAriaLabel={`Rename chat: ${title}`}
      pencilAriaLabel="Rename chat"
      inputAriaLabel="Chat title"
      readOnlyTestId="chat-breadcrumb-title"
      triggerTestId="chat-breadcrumb-rename"
      pencilTestId="chat-breadcrumb-rename-button"
      inputTestId="chat-rename-input"
    />
  );
}
